import { GetRequestOptions } from "./grunt";

const getOsobePth=process.env.REACT_APP_GRUNT_API+"/osoba";
const getOsobeDomacePth=process.env.REACT_APP_GRUNT_API+"/osoba/domaca";

const getStraneOsobePth=process.env.REACT_APP_GRUNT_API+"/osoba/strana";
const getPosjednikKnjigaPth=process.env.REACT_APP_GRUNT_API+"/osoba/posjednikknjiga";
const getKlaoniceOsobePth=process.env.REACT_APP_GRUNT_API+"/osoba/klaonica";
const StatusOk={status:200};
const getOsobe=async({orderbycolumn="naziv", orderby="asc",offset=0,limit=1000})=>{
    let _pth=getOsobePth+`/${orderbycolumn}/${orderby}/${offset}/${limit}`;
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getPosjednikePrijasnje=async()=>{
    const _pth=getOsobePth+"/posjednik/prijasnji";
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}
const getPosjednikeNove=async()=>{
    const _pth=getOsobePth+"/posjednik/novi";
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getOsobeDomace=async({osobe=[],orderbycolumn="naziv", orderby="asc",offset=0,limit=1000})=>{
    let _pth=getOsobeDomacePth+`/${orderbycolumn}/${orderby}/${offset}/${limit}`;
    let _o=""
    if (osobe.length>0) {
        osobe.forEach((item,index)=>{
            if (index===0) {
                _o=_o+`${String(item)}`;    
            } else {
                _o=_o+`|${String(item)}`;
            }
            
        })
    }
    if (_o!=="") {
        _pth+="?osobeid="+_o;
    }
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}
const getOsobeById=async({osobe=[]})=>{
    let _pth=getOsobePth;
    let _o=""
    if (osobe.length>0) {
        osobe.forEach((item,index)=>{
            if (index===0) {
                _o=_o+`${String(item)}`;    
            } else {
                _o=_o+`|${String(item)}`;
            }
            
        })
    }
    if (_o!=="") {
        _pth+="?osobeid="+_o;
    }
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getOsobePosjednikKnjiga=async({orderbycolumn="naziv", orderby="asc",offset=0,limit=1000})=>{
    let _pth=getPosjednikKnjigaPth+`/${orderbycolumn}/${orderby}/${offset}/${limit}`;
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getOsobeStrane=async({orderbycolumn="naziv", orderby="asc",offset=0,limit=1000,drzavaSifra=""})=>{

    let _pth=getStraneOsobePth+`/${orderbycolumn}/${orderby}/${offset}/${limit}`;
    /*if (drzavaSifra!=="") {
        _pth=_pth+`?drzavasifra=${drzavaSifra}`;
    }*/
   
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getOsobeKlaonice=async({orderbycolumn="naziv", orderby="asc",offset=0,limit=1000})=>{
    let _pth=getKlaoniceOsobePth+`/${orderbycolumn}/${orderby}/${offset}/${limit}`;
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const addOsoba=async (osoba)=>{
    try {
        let _pth=getOsobePth;
        let reqopt=GetRequestOptions("POST");
        reqopt.body=JSON.stringify(osoba);
        if (osoba.drzava_sifra!=="HR") {
           _pth=getStraneOsobePth; 
        }
        const r=await fetch(_pth,reqopt);
        const StatusOk={status:200};
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (ex) {
        return {code: ex.code, message: "Greška kod pohrane podatka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const updateOsoba=async (osoba)=>{
    try {
        let _pth=getOsobePth;
        if (osoba.drzava_sifra!=="HR") {
            _pth=getStraneOsobePth; 
         }
        let reqopt=GetRequestOptions("PUT");
        reqopt.body=JSON.stringify(osoba);
        const r=await fetch(_pth,reqopt);
        const StatusOk={status:200};
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (ex) {
        return {code: ex.code, message: "Greška kod ispravka podatka. " + ex.message, status: ex.status, name: ex.name};
    }
}

export {getOsobe, addOsoba, updateOsoba,getOsobeDomace, getOsobeStrane,getOsobeKlaonice,getOsobePosjednikKnjiga,getOsobeById,getPosjednikePrijasnje,getPosjednikeNove};